// extracted by mini-css-extract-plugin
export default {"link":"_25846bb0e3c866c4","dismissButton":"_90f71860df9ee928"};